import _ from 'lodash'
import {
    justifyButton,
    validateButton,
    saveButton,
    returnButton,
    submitButton,
    acceptButton,
    refuseButton,
    examineButton,
    transmitPaymentsButton,
    closePaymentsButton,
    updateDocumentsButton, updateButton, sendMessageButton
} from '../utils'
import path from "path";
import {basicContext} from "../../../utils/contextUtils";

export const getButtonsForModule = async (applicationOrPayment, context) => {
    const statusId = _.get(applicationOrPayment, 'status.id');
    const { moduleId } = context.clientContext;
    let buttons = []

    switch (moduleId) {
        case 'm-C-submission':
            if (statusId === 'draft') {
                buttons = [submitButton, saveButton, returnButton]
            }
            if(statusId === 'questioned') {
                return [updateButton, saveButton, returnButton]
            }
            break
        case 'm-C-study':
            if (['ongoing', 'updated'].includes(statusId)) {
                buttons = [
                    {
                        ...acceptButton,
                        tKey: 'TRANSMETTRE POUR DÉCISION',
                    },
                    examineButton,
                    returnButton
                ]
            }
            break
        case 'm-C-decision':
            if (statusId === 'controlled') {
                buttons = [acceptButton, refuseButton, examineButton, returnButton]
            }
            break
        case 'm-C-reliefFundPayment':
            if (statusId === 'accepted') {
                buttons = [transmitPaymentsButton, sendMessageButton, closePaymentsButton, saveButton, returnButton]
            }
            break
        case 'm-C-reliefFundPaymentValidation':
            if(statusId === 'ongoing') {
                buttons = [validateButton, refuseButton, justifyButton, returnButton]
            }
            break
        case 'm-C-followUp':
            if( !['closed', 'refused'].includes(statusId) ) {
                const cUser = await global.app.C.CUser.get({kpUser: new global.ObjectID(context.user.id)}, {
                    ...basicContext(context),
                    fieldPath: [
                        'id',
                        'functions.id',
                        'functions.submissionAuthorization',
                        'functions.studyAuthorization',
                        'functions.decisionAuthorization',
                        'functions.solicitationsManagementAuthorization',
                        'functions.liberationAuthorization',
                        'organization.id',
                        'organization.hasShelters'
                    ]
                })
                const userIsAdmin = ['studyAuthorization', 'decisionAuthorization', 'solicitationsManagementAuthorization', 'liberationAuthorization'].some(
                    key => cUser.functions.some(
                        userFunction => !!userFunction[key]
                    )
                )

                const userId = _.get(context, 'user.id')
                const submitterId = _.get(applicationOrPayment, 'submitter.id')
                const userIsSubmitter = userId && submitterId && new global.ObjectID(userId).toString() === new global.ObjectID(submitterId).toString()

                if (userIsAdmin){
                    buttons.push(sendMessageButton)
                }
                if (userIsSubmitter) {
                    buttons.push(updateDocumentsButton)
                }
            }
    }

    // Adding a return button if not already included, to always allow going back
    if (!buttons.includes(returnButton)) {
        buttons.push(returnButton)
    }

    return buttons
}


export function prepareDefaultMail() {

    return {
        from: `"CNDA - Fonds de Secours Exceptionnel"secours@defensedelanimal.fr`,
        replyTo: "secours@defensedelanimal.fr",
        templateDir: path.join(global.appRoot, global.isProd ? 'buildServer' : 'src' , '/server/models/cnda/templates'),
        verbose: {
            general: true,
        }
    }
}

export async function getUsersWithAuthorization(authorization) {
    return await global.app.C.CUser.collection
        .aggregate([
            { $lookup: {
                    from: 'c.function',
                    let: { 'functionIds': { $ifNull: ['$functions', []] } },
                    pipeline: [
                        {
                            $match: {
                                [authorization]: true,
                                '$expr': { '$in': ['$_id', '$$functionIds'] }
                            }
                        },
                    ],
                    as:'functions'
                }
            },
            {
                $match: {
                    $expr: { $gt: [{ $size: '$functions' }, 0] }
                }
            }
        ]).toArray()
}

// Statuts de dossier libéralités qui ne comptent pas comme « en cours »
const nonOngoingLiberalityStatuses = ['draft', 'incomplete', 'rejected', 'closed']

export async function getOngoingLiberalitiesSummary(organizationId, context) {
    const emptySummary = {filesCount: 0, benefactors: '', propertyTypes: '', netForecast: 0, advanceBalance: 0, paidAmount: 0}
    if (!organizationId) return emptySummary

    const beneficiary = new global.ObjectID(organizationId)

    const partitions = await global.app.C.AssetPartition.find({
        ...basicContext(context),
        query: {beneficiary},
        fieldPath: [
            'id',
            'estimatedBeneficiaryNetValue',
            'assetInfos.id',
            'assetInfos.typeOfProperty.name',
            'assetInfos.liberalityRecord.id',
            'assetInfos.liberalityRecord.status.id',
            'assetInfos.liberalityRecord.benefactor'
        ]
    })

    const ongoingPartitions = partitions.filter(partition => {
        const record = _.get(partition, 'assetInfos.liberalityRecord')
        return record && !nonOngoingLiberalityStatuses.includes(_.get(record, 'status.id'))
    })
    if (!ongoingPartitions.length) return emptySummary

    const records = _.uniqBy(ongoingPartitions.map(partition => partition.assetInfos.liberalityRecord), 'id')
    const assetIds = _.uniq(ongoingPartitions.map(partition => partition.assetInfos.id))

    const [advances, departures] = await Promise.all([
        global.app.C.LiberalityAdvance.find({
            ...basicContext(context),
            query: {beneficiary},
            fieldPath: ['id', 'balance']
        }),
        global.app.C.LiberalityReversionDeparture.find({
            ...basicContext(context),
            // TODO: à confirmer avec Mouad — « Versement (€) » assimilé à reversionAmount (forme Reversion)
            query: {
                beneficiary,
                departureForm: 'reversion',
                asset: {$in: assetIds.map(id => new global.ObjectID(id))}
            },
            fieldPath: ['id', 'reversionAmount']
        })
    ])

    return {
        filesCount: records.length,
        benefactors: _.uniq(records.map(record => record.benefactor).filter(Boolean)).join(', '),
        propertyTypes: _.uniq(ongoingPartitions.map(partition => _.get(partition, 'assetInfos.typeOfProperty.name')).filter(Boolean)).join(', '),
        netForecast: _.sumBy(ongoingPartitions, partition => partition.estimatedBeneficiaryNetValue || 0),
        advanceBalance: _.get(advances, '0.balance') || 0,
        paidAmount: _.sumBy(departures, departure => departure.reversionAmount || 0)
    }
}

// Montant au format français, 2 décimales pour les € comme pour les kg : « 5 000,00 € » ou « 800,00 kg »
export function formatReliefFundAmount(value, unitId) {
    const formatted = new Intl.NumberFormat('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(Number(value || 0))
    return `${formatted} ${unitId === 'kilogram' ? 'kg' : '€'}`
}
